import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import Tr from "../../components/tr/Tr";

const LeasePurpose = () => {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  const token = loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { displayName: "S.No.", render: (item, index) => (currentPage - 1) * 10 + index + 1 },
    { displayName: "Name", key: "name" },
    { displayName: "Description", key: "description" },
  ];

  const fetchLeasePurposes = async (pageNumber = 1) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/lease-purpose/all`,
        {
          page_number: pageNumber,
          page_size: 10,
          order_by: "DESC",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const resData = response.data;
      const list =
        resData?.leasePurposes ||
        resData?.data ||
        resData?.content ||
        resData?.lease_purposes ||
        (Array.isArray(resData) ? resData : []);

      setData(list);
      setTotalPages(resData?.totalPage || resData?.total_page || 1);
    } catch (error) {
      console.error("Error fetching lease purposes:", error);
      showToast("Error fetching lease purposes", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeasePurposes(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/lease-purpose/delete/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.data?.statusType === "SUCCESS") {
        setData((prev) => prev.filter((item) => item.id !== itemId));
        showToast("Lease Purpose deleted successfully", { type: "success" });
      } else {
        showToast(response.data?.text || "Failed to delete item", { type: "error" });
      }
    } catch (error) {
      console.error("Error deleting lease purpose:", error);
      showToast("Error occurred during deletion", { type: "error" });
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Lease Management", link: "/lease-purpose" },
    { label: "Lease Purpose", link: "/lease-purpose", active: true },
  ];

  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />

          <Row>
            <Col lg={12} md={12} sm={12}>
              {data?.length === 0 && !isLoading ? (
                <Tr
                  columns={columns}
                  initialValues={{}}
                  title="No Lease Purpose Found"
                  buttonName="Create"
                  btnLink="lease-purpose/add-leasePurpose"
                  titleHeader="Lease Purposes"
                />
              ) : (
                <List
                  title="Lease Purposes"
                  data={data}
                  columns={columns}
                  button="Create"
                  route="lease-purpose"
                  to="add-leasePurpose"
                  handleDelete={handleDelete}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default LeasePurpose;
